export type Falsy = false | "" | 0 | -0 | 0n | null | undefined;
export const isFalsy = (val: unknown): val is Falsy => !val;

export type Truthy<T> = Exclude<T, Falsy>;
export const isTruthy = <T extends unknown>(val: T): val is Truthy<T> => !!val;
